module.exports = __webpack_public_path__ + "img/everydayink-mobile.13a80060.webp";